import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { exchangeTelegramToken } from '../api/auth';

/**
 * Telegram auto-login: strips `?tg_token=` from URL when user is already
 * authenticated (JWT present). The unauthenticated exchange flow runs in
 * LoginPage before PrivateRoutes checks the JWT.
 *
 * Bot URL contract:
 *   https://my.linzametrics.com/usage/dashboard?tg_token=<one-time-uuid>
 */
export function useTelegramAutoLogin() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const tgToken = searchParams.get('tg_token');
    if (!tgToken) return;

    const existingJwt = localStorage.getItem('jwt');
    if (existingJwt) {
      // Already logged in — strip the token so it doesn't sit in the URL bar.
      setSearchParams(prev => {
        prev.delete('tg_token');
        return prev;
      }, { replace: true });
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const resp = await exchangeTelegramToken(tgToken);
        if (cancelled) return;
        localStorage.setItem('jwt', resp.data.access);
        // Hard reload so PrivateRoutes re-evaluates auth state from scratch.
        window.location.href = '/usage/dashboard';
      } catch {
        // Endpoint not implemented yet — silently leave the user on /login.
        if (cancelled) return;
        setSearchParams(prev => {
          prev.delete('tg_token');
          return prev;
        }, { replace: true });
      }
    })();

    return () => { cancelled = true; };
  }, [searchParams, setSearchParams]);
}
